import script from "./owner.vue?vue&type=script&setup=true&lang=js"
export * from "./owner.vue?vue&type=script&setup=true&lang=js"

import "@/styles/trademark-registration-process.css?vue&type=style&index=0&id=3a9c4323&scoped=true&lang=css&external"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-3a9c4323"]])

export default __exports__